import { TableTypes } from '@/constant';
import { memo, useCallback } from 'react';

import { ColumnTypes, TableWithActions } from '..';
import { useLogic } from './logic';
import AddFooterInfo from './modal-add';
import { validationSchema } from './modal-add/modal-add.config';
import { IProps } from './type';

const FooterInfoComponent = (props: IProps) => {
	const { columns, canEdit, rowSelection, total, fetchData } = useLogic(props);
	const ActionsRightComponent = useCallback(() => {
		return <AddFooterInfo fetchData={fetchData} total={total} />;
	}, [fetchData, total]);
	return (
		<div className="bg-white">
			<TableWithActions
				columns={columns as ColumnTypes}
				actionsRight={<ActionsRightComponent />}
				titleInDetail="Footer 정보"
				actionHidden={!canEdit}
				rowKey="id"
				editable={canEdit}
				pagination={false}
				rowSelection={canEdit ? { ...rowSelection } : undefined}
				tableType={TableTypes.FOOTER_INFO}
				onDeleteSuccessCallback={fetchData}
				validationSchema={validationSchema}
			/>
		</div>
	);
};

export default memo(FooterInfoComponent);
